<script setup lang="ts">
import type { AppGame } from '~~/models/appGame'

interface Props {
  app: AppGame
}

const props = defineProps<Props>()
</script>

<template>
  <div class="app-entry">
    <div class="app-icon">
      <img
        :src="`${props.app.versions[0].image}`"
        :alt="props.app.name"
        width="28"
        height="28"
      />
    </div>
    <span class="name">
      {{ props.app.name }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.app-entry {
  display: flex;
  align-items: center;

  .name {
    margin-left: 1rem;
    font-size: 0.85rem;
  }

  @media (min-width: $breakpoint-sm) {
    .app-icon img {
      width: 38px;
      height: 38px;
    }

    .name { font-size: 1rem; }
  }
}

.app-icon {
  padding: 1rem;
  border-radius: $border-radius-circular;
  background-color: rgba($color-black, 0.25);

  img { display: block; }
}
</style>
